"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIMIZATION_TYPE = exports.EXTERNAL_SERVICE_TYPE = exports.POSTGRES_USER_ACCESS_RIGHT = exports.SOURCE = exports.COLUMN_TYPE = void 0;
/**
 * Column variable type
 */
var COLUMN_TYPE;
(function (COLUMN_TYPE) {
    COLUMN_TYPE["INTEGER"] = "integer";
    COLUMN_TYPE["FLOAT"] = "float";
    COLUMN_TYPE["DECIMAL"] = "decimal";
    COLUMN_TYPE["STRING"] = "string";
    COLUMN_TYPE["BOOLEAN"] = "boolean";
})(COLUMN_TYPE || (exports.COLUMN_TYPE = COLUMN_TYPE = {}));
var SOURCE;
(function (SOURCE) {
    SOURCE["WEB"] = "WEB";
    SOURCE["MOBILE"] = "MOBILE";
    SOURCE["CUSTOMER"] = "CUSTOMER";
})(SOURCE || (exports.SOURCE = SOURCE = {}));
var POSTGRES_USER_ACCESS_RIGHT;
(function (POSTGRES_USER_ACCESS_RIGHT) {
    POSTGRES_USER_ACCESS_RIGHT["FULLACCESS"] = "FULLACCESS";
    POSTGRES_USER_ACCESS_RIGHT["READONLY"] = "READONLY";
})(POSTGRES_USER_ACCESS_RIGHT || (exports.POSTGRES_USER_ACCESS_RIGHT = POSTGRES_USER_ACCESS_RIGHT = {}));
var EXTERNAL_SERVICE_TYPE;
(function (EXTERNAL_SERVICE_TYPE) {
    EXTERNAL_SERVICE_TYPE["FTP"] = "FTP";
    EXTERNAL_SERVICE_TYPE["SUPERSET"] = "SUPERSET";
})(EXTERNAL_SERVICE_TYPE || (exports.EXTERNAL_SERVICE_TYPE = EXTERNAL_SERVICE_TYPE = {}));
var OPTIMIZATION_TYPE;
(function (OPTIMIZATION_TYPE) {
    OPTIMIZATION_TYPE["PARTITION"] = "PARTITION";
    OPTIMIZATION_TYPE["BACKTRACK_TIME"] = "BACKTRACK_TIME";
    OPTIMIZATION_TYPE["INDEX"] = "INDEX";
})(OPTIMIZATION_TYPE || (exports.OPTIMIZATION_TYPE = OPTIMIZATION_TYPE = {}));
